// extracted by mini-css-extract-plugin
export default {"category_menu":"CategoriesHeader_category_menu__0loUX","category_list":"CategoriesHeader_category_list__TckWH","category_divider":"CategoriesHeader_category_divider__Y+qb1"};